<template>
  <div class="c-filter">
    <ElForm class="elementui-common-form-styles" v-highlight label-width="50" inline>
      <ElFormItem label-width="0">
        <el-input v-model="formData.keyword" :placeholder="keyWordMsg" style="width: 244px" @keyup.enter.native="search">
          <el-select v-model="searchType" slot="prepend" style="width: 74px">
            <el-option :value="1" label="计划"></el-option>
            <el-option :value="2" label="素材(新)"></el-option>
            <el-option :value="3" label="落地页"></el-option>
            <el-option :value="4" label="素材(老)"></el-option>
          </el-select>
          <i slot="append" @click="search" class="el-icon-search"></i>
        </el-input>
      </ElFormItem>
      <ElFormItem label="平台" label-width="38">
        <el-select
          v-model="formData.platform"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 90px"
        >
          <el-option v-for="item in platformData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="游戏组">
        <ThrottleSelector
          group-cache-name="commonGameGroupIds"
          style="width: 180px"
          v-model="formData.gameGroupId"
          :list="GAME_GROUPS"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="游戏" label-width="38">
        <ThrottleSelector
          group-cache-name="commonGameIds"
          style="width: 180px"
          v-model="formData.gameId"
          :list="GAMES"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="媒体" label-width="38">
        <ThrottleSelector
          group-cache-name="commonMediaIds"
          style="width: 160px"
          v-model="formData.mediaId"
          :list="MEDIAS"
          placeholder="全部"
          filterable
          clearable
          @change="handleMedia"
        />
      </ElFormItem>

      <ElFormItem label="媒体版本" label-width="60">
        <el-select v-model="formData.subMediaId" style="width: 160px" collapse-tags clearable>
          <el-option v-for="item in subMediaIds[formData.mediaId] || []" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="投放位">
        <el-select
          v-model="formData.advPositionId"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in AdvertPositionData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="优化目标" label-width="60">
        <el-select
          v-model="formData.optimizationType"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in optimizationData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="深度优化" label-width="60">
        <el-select
          v-model="formData.deepOptimizationType"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in deepOptimizationData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="项目组">
        <el-select
          v-model="formData.projectGroupId"
          :popper-append-to-body="false"
          multiple
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 160px"
        >
          <el-option v-for="pro in PROJECT_GROUP" :key="pro.id" :value="pro.id" :label="pro.name" style="width: 200px"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="人员" label-width="38">
        <ThrottleSelector
          group-cache-name="commonOpIds"
          style="width: 180px"
          v-model="formData.opId"
          :list="PTOM_USERS"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="账号" label-width="38">
        <ThrottleSelector
          group-cache-name="commonAccountIds"
          style="width: 180px"
          v-model="formData.adAccountId"
          :list="MEDIA_ACCOUNTS"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="素材绑定" label-width="60">
        <el-select
          v-model="formData.bindMaterial"
          :popper-append-to-body="false"
          clearable
          collapse-tags
          filterable
          placeholder="全部"
          style="width: 120px"
        >
          <el-option v-for="item in materialBindList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="操作状态" label-width="60">
        <el-select v-model="formData.mediaOptStatus" style="width: 110px" multiple collapse-tags clearable>
          <el-option v-for="item in planStatus.adSwitchStatusEnums" :key="item.chEnum" :label="item.chName" :value="item.chEnum">
          </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="计划状态" label-width="60">
        <el-select v-model="formData.mediaStatus" style="width: 160px" multiple collapse-tags clearable>
          <el-option v-for="(item, index) in planStatus.adStatusEnums" :key="index" :label="item.chName" :value="item.chEnum"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="是否代投" label-width="60">
        <el-select v-model="formData.proxyFlag" style="width: 160px" collapse-tags clearable>
          <el-option v-for="item in proxyStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="一键起量" label-width="60">
        <el-select v-model="formData.raiseStatus" style="width: 120px" collapse-tags clearable>
          <el-option
            v-for="item in [
              { label: '未知', value: AUTO_ACQUISITION_STATUS.UNKNOWN },
              { label: '起量中', value: AUTO_ACQUISITION_STATUS.ENABLE },
              { label: '未开启', value: AUTO_ACQUISITION_STATUS.CLOSED },
              { label: '已完成', value: AUTO_ACQUISITION_STATUS.FINISHED }
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="新建时间" label-width="60">
        <DateRangePicker v-model="formData.datetime" style="width: 220px"></DateRangePicker>
      </ElFormItem>
      <ElFormItem class="bg-transparent">
        <div style="display: flex; align-items: center">
          <ElButton type="primary" @click="sendEvent" class="search-button">查询</ElButton>
          <ElButton @click="showAdditionFilterModal">更多筛选</ElButton>
          <el-tooltip effect="dark" :disabled="additionPreviewText.length === 0" placement="bottom">
            <div slot="content">
              <p style="line-height: 18px" v-for="(text, index) in additionPreviewText" :key="index">{{ text }}</p>
            </div>
            <el-badge :hidden="additionPreviewText.length <= 0" :value="additionPreviewText.length">&ensp; </el-badge>
          </el-tooltip>
        </div>
      </ElFormItem>
    </ElForm>

    <Modal
      title="更多筛选"
      width="680px"
      :visible.sync="showAdditionFilter"
      @confirm="onAdditionFilterConfirmAction"
      @cancel="onAdditionFilterCancel"
    >
      <AdditionFilterForm ref="additionFormRef" :form-data="additionForm" :rows="additionFilterFormItems">
        <template #clear>
          <el-button type="text" @click="clearAdditionFilterForm">清空筛选项</el-button>
        </template>
      </AdditionFilterForm>
    </Modal>
  </div>
</template>
<script>
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { isEmpty, trim } from '@/common/js/utils'
import { setLocal, getLocal, div, mul } from '@/common/js/api'
import { SUB_MEDIA_OPTIONS_BY_MEDIA } from '@/common/js/constants'
import { AUTO_ACQUISITION_STATUS } from './modify-auto-acquisition-batch/consts/index.js'
import { optimization, deepOptimization, additionFilterFormItems, ADDITION_ENUM } from './detail.data.js'
import { getPtomDetailPlanStatus } from '@/api/ptom.data.model'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'

import ThrottleSelector from '@/components/throttle-select/index.vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import AdditionFilterForm from './addition-filter-form.vue'
import { initPageData, PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS } from '@/data/global-opts'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS])

const getPercentageField = (field) => ['createRole24hRoi', 'newRoleRate'].includes(field)
const initAdditionFilterForm = (existConditions) => {
  const additionForm = {}
  for (const item of additionFilterFormItems) {
    const existItem = existConditions?.find((c) => c.field === item.prop)

    additionForm[item.prop] = {
      value1: '',
      value2: '',
      condition: 1
    }

    // 常用查询参数回显
    if (existItem) {
      const { operatorType, field, value1 = '', value2 = '' } = existItem
      const isPercentage = getPercentageField(field)
      additionForm[item.prop] = {
        value1: isPercentage ? String(mul(value1, 100)) : value1,
        value2: isPercentage ? String(mul(value2, 100)) : value2,
        condition: operatorType
      }
    }
  }

  return additionForm
}
export default {
  name: 'detailFilter',
  components: { DateRangePicker, AdditionFilterForm, Modal, ThrottleSelector },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    // 广告位列表数据，根据媒体筛选
    AdvertPositionData() {
      let data = []
      const { mediaId } = this.formData
      if (mediaId && parseInt(mediaId) > 0) {
        data = this.MEDIA_POSITION.filter((ret) => ret.mediaId === parseInt(mediaId))
      }
      return data
    },
    keyWordMsg() {
      let msg = ''
      if (this.searchType === 1) msg = '计划名称'
      else if (this.searchType === 2) msg = '素材名称'
      else if (this.searchType === 4) msg = '素材名称'
      else msg = '落地页ID'
      return `请输入${msg}`
    },
    queryKey() {
      let msg = ''
      if (this.searchType === 1) msg = 'planName'
      else if (this.searchType === 2) msg = 'subMaterialName'
      else if (this.searchType === 4) msg = 'imageName'
      else msg = 'landingPageIdStr'
      return msg
    },

    optimizationData() {
      let data = []
      const { mediaId } = this.formData
      if (mediaId && parseInt(mediaId) > 0) {
        data = this.optimization.filter((ret) => ret.media === parseInt(mediaId))
      }
      return data
    },
    deepOptimizationData() {
      let data = []
      const { mediaId } = this.formData
      if (mediaId && parseInt(mediaId) > 0) {
        data = this.deepOptimization.filter((ret) => ret.media === parseInt(mediaId))
      }
      return data
    }
  },
  data() {
    return {
      formData: {
        datetime: [],
        gameId: '', // 游戏id
        gameGroupId: '', // 游戏组id
        projectGroupId: [], // 项目组id
        mediaId: '', // 媒体id
        subMediaId: '', // 子媒体id
        advPositionId: '', // 广告位id
        optimizationType: '',
        deepOptimizationType: '',
        opId: '', // 人员id
        adAccountId: '', // 账号
        bindMaterial: '', // 素材绑定状态
        platform: '',
        keyword: '',
        mediaStatus: [],
        mediaOptStatus: [],
        proxyFlag: '', // 是否代投
        raiseStatus: ''
      },
      optimization,
      deepOptimization,
      AUTO_ACQUISITION_STATUS,

      planStatus: {},
      materialBindList: [
        { name: '已绑定', id: 1 },
        { name: '未绑定', id: 0 }
      ],
      proxyStatus: [
        { id: 1, name: '是' },
        { id: 0, name: '否' }
      ],
      platformData: [
        { id: 1, name: 'Andriod' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' }
      ],
      subMediaIds: SUB_MEDIA_OPTIONS_BY_MEDIA,

      additionFormRef: null,
      showAdditionFilter: false,
      additionPreviewText: [],
      filteredAdditionFormData: [],
      additionFilterFormItems,
      additionForm: initAdditionFilterForm(),

      searchType: 1 // 搜索类型
    }
  },
  created() {
    getPtomDetailPlanStatus().then((status) => {
      this.planStatus = status || {}
    })
  },
  methods: {
    /**
     * @description: 外部组件调用，回显当前根据保存的查询条件
     * @param {*} formData
     * @return {*}
     */
    setFormData(formData) {
      const { compareConditions, ...form } = formData
      this.formData = { ...Object.assign(this.formData, form) }

      if (Array.isArray(compareConditions) && compareConditions?.length) {
        this.additionForm = initAdditionFilterForm(compareConditions)

        // 当选择已知查询条件时，更多筛选进行个数和详情的回显
        this.onAdditionFilterConfirm(this.additionForm)
      } else {
        this.additionPreviewText = []
        this.filteredAdditionFormData = []
        this.clearAdditionFilterForm()
      }
    },
    showAdditionFilterModal() {
      this.showAdditionFilter = true
    },
    /**
     * @description: 过滤掉更多筛选条件的、当前有值的项
     * @param {*} formData
     * @return {*}
     */
    additionFormDataFilter(formData) {
      const formFileds = []
      for (const key in formData) {
        const item = formData[key]
        if (!item.value1.trim()) continue
        const isPercentage = getPercentageField(key)
        const field = {
          field: key,
          operatorType: item.condition,
          value1: item.value1
        }

        if (isPercentage) {
          field.value1 = div(item.value1, 100)
        }

        if (item.condition === ADDITION_ENUM.RANGE) {
          if (isPercentage) {
            field.value2 = div(item.value2, 100)
          } else {
            field.value2 = item.value2
          }
        }
        formFileds.push(field)
      }

      return formFileds
    },
    async onAdditionFilterConfirmAction() {
      await this.onAdditionFilterConfirm()
      this.search()
    },
    async onAdditionFilterConfirm(exsitFormData) {
      try {
        let additionFormData = exsitFormData

        if (!additionFormData) {
          await this.$refs.additionFormRef.validate()
          additionFormData = this.$refs.additionFormRef.getForm()
        }
        // 只需要有值的项
        const filteredAdditionFormData = this.additionFormDataFilter(additionFormData)
        const previewText = []
        for (const key in filteredAdditionFormData) {
          const formData = filteredAdditionFormData[key]
          for (const i in additionFilterFormItems) {
            const fieldItem = additionFilterFormItems[i]
            if (fieldItem.prop === formData.field) {
              const { conditions, prop, label, unit } = fieldItem
              let { operatorType, value1, value2 } = formData
              const operatorTypeText = conditions.find((c) => c.value === operatorType)?.label
              const isPercentage = getPercentageField(prop)

              if (isPercentage) {
                value1 = mul(value1, 100)
                value2 = value2 && value2 > 0 ? mul(value2, 100) : value2
              }
              const value1Text = operatorType === ADDITION_ENUM.EQUAL ? '不限' : `${value1}${unit}`
              previewText.push(`${label}${operatorTypeText}${value1Text}${value2 ? '-' + `${value2}${unit}` : ''}`)
            }
          }
        }

        // 更多筛选条件详情文本显示
        this.additionPreviewText = previewText
        // 用作查询时的提交条件
        this.filteredAdditionFormData = filteredAdditionFormData
        this.onAdditionFilterCancel()

        return Promise.resolve()
      } catch (e) {
        console.log('eeeeeee output: ', e)
        return Promise.reject(new Error('onAdditionFilterConfirm error'))
      }
    },
    clearAdditionFilterForm() {
      this.additionForm = initAdditionFilterForm()
    },
    onAdditionFilterCancel() {
      this.showAdditionFilter = false
    },
    /**
     * @description: 添加导出任务时转化查询条件为可读的字符串
     * @param {*} extraParams
     * @param {*} pageType
     * @return {*}
     */
    getTransferedTaskQueryConditions(extraParams, pageType) {
      return transferTaskQueryConditions.call(this, { ...this.buildParams(), ...extraParams }, pageType)
    },
    buildParams() {
      const params = {}
      const { projectGroupId, datetime, mediaStatus, mediaOptStatus, keyword, ...restFormFields } = this.formData
      for (const key in restFormFields) {
        if (!isEmpty(restFormFields[key])) {
          params[key] = restFormFields[key]
        }
      }

      if (projectGroupId?.length) {
        params.projectGroupOpIds = projectGroupId.join(',')
      }

      if (mediaStatus?.length) {
        params.mediaStatusStr = mediaStatus.join(',')
      }

      if (mediaOptStatus?.length) {
        params.mediaOptStatusStr = mediaOptStatus.join(',')
      }

      // 处理时间段
      if (datetime?.length) {
        const [createBeginTime, createEndTime] = datetime
        params.createBeginTime = createBeginTime
        params.createEndTime = createEndTime
      }

      if (!params.platform) params.platform = '0'
      if (keyword) {
        params[this.queryKey] = trim(keyword)
      }

      if (this.filteredAdditionFormData?.length) {
        params.compareConditions = this.filteredAdditionFormData
      }

      return params
    },
    sendEvent(type) {
      const params = this.buildParams()
      if (type === 'save') {
        // 不需要时间参数
        const { createBeginTime, createEndTime, ...saveParams } = params
        this.$emit('on-save', saveParams)
      } else {
        this.$emit('on-change', params)
        this.filterSaveData(params)
      }
    },
    saveFilter() {
      this.sendEvent('save')
    },
    search() {
      this.sendEvent()
    },

    /**
     * @description: 最近使用本地缓存
     * @param {*} params
     */
    filterSaveData(params) {
      if (params.gameId) this.setRecentlyUsed(params.gameId, 'commonGameIds')
      if (params.gameGroupId) this.setRecentlyUsed(params.gameGroupId, 'commonGameGroupIds')
      if (params.mediaId) this.setRecentlyUsed(params.mediaId, 'commonMediaIds')
      if (params.opId) this.setRecentlyUsed(params.opId, 'commonOpIds')
      if (params.adAccountId) this.setRecentlyUsed(params.adAccountId, 'commonAccountIds')
    },
    setRecentlyUsed(id, localName) {
      let storage = getLocal(localName)
      if (!storage) storage = [id]
      else {
        if (!storage.includes(id)) storage.push(id)
        if (storage.length > 5) storage.splice(0, 1)
      }
      setLocal(localName, storage)
    },

    /**
     * @description: 清除一些根据媒体获得的表单信息
     */
    handleMedia() {
      this.formData.advPositionId = ''
      this.formData.optimizationType = ''
      this.formData.deepOptimizationType = ''
      this.formData.subMediaId = ''
    }
  }
}
</script>
